<template>
  <v-dialog
    content-class="exercise-preview"
    v-model="showDialog"
    persistent
    max-width="400"
    @click:outside="onClickOutside"
    @keydown="onKeydown"
  >
      <v-btn
        color="bh-white"
        small
        rounded
        height="24"
        width="24"
        min-width="24"
        max-width="24"
        elevation="0"
        class="mt-6 mr-6 pa-0"
        @click="closeDialog"
      >
        <v-icon color="accent">mdi-close</v-icon>
      </v-btn>
      <v-card v-if="exercise">
          <v-card-title class="headline">
            <div class="exercise-preview__thumbnail--wrapper">
              <img class="exercise-preview__thumbnail" :src="exercise.media && exercise.media.thumbnailUrl ? exercise.media.thumbnailUrl : require('@/assets/placeholder_image.png')"/>
              <div class="exercise-preview__thumbnail--icon" :style="{'background':typeIcon.color}">
                <v-icon size="16">{{typeIcon.icon}}</v-icon>
                <span v-if="exercise.type == 'ACTIVITY' && exercise.time">{{exercise.time =='EVENING' ? 'PM':'AM'}}</span>
              </div>
            </div>
            <div class="exercise-preview__title">
              <h5>{{exercise.title}}</h5>
              <p>{{exercise.description}}</p>
              <div class="exercise-preview__rating" v-if="exercise.averageRating">
                <rating-stars :rating="exercise.averageRating"/><span>Avg: <strong>{{exercise.averageRating}}</strong></span>
              </div>
            </div>
          </v-card-title>
          
          <v-card-text>
            <v-tabs 
              class="exercise-preview__tabs"
              v-model="tab"
              fixed-tabs
              color="accent"
              v-if="exercise.report"
            >
              <v-tabs-slider></v-tabs-slider>
              <v-tab>Quick view</v-tab>
              <v-tab>Report</v-tab>
            </v-tabs>
            <v-tabs-items v-model="tab">
              <v-tab-item class="exercise-preview__tab quick-view">
                <v-card class="exercise-preview__desc--wrapper">
                  <v-img
                    height="400"
                    :src="exercise.media && exercise.media.previewUrl ? exercise.media.previewUrl : require('@/assets/placeholder_image.png')"
                  >
                    <div class="gradient"></div>
                  </v-img>
                  <div class="exercise-preview__attributes">
                    <div v-if="exercise.type == 'EXERCISE' && exercise.time"><strong>{{exercise.time}}</strong> Minutes</div>
                    <div v-if="exercise.weight"><strong>{{exercise.weight}}</strong> Lbs</div>
                    <div v-if="exercise.repetitions"><strong>{{exercise.repetitions}}</strong> Reps</div>
                    <div v-if="exercise.series"><strong>{{exercise.series}}</strong> Series</div>
                    <div v-if="exercise.restTimeBetweenSeries"><strong>{{exercise.restTimeBetweenSeries}}</strong> Rest Minutes</div>
                    <div v-if="exercise.distance"><strong>{{exercise.distance}}</strong> Miles</div>
                    <div v-if="exercise.circuits"><strong>{{exercise.circuits}}</strong> Circuits</div>
                  </div>
                  <div class="exercise-preview__desc">
                    <p>{{exercise.description}}</p>
                    <v-btn v-if="exercise.externalUrl" :href="exercise.externalUrl" outlined rounded color="bhWhite" target="_blank">External link</v-btn>
                  </div>
                </v-card>
                <v-btn v-if="exercise.media" class="exercise-preview__expand" small icon text @click="previewResource">
                  <v-icon>bhi-expand</v-icon>
                </v-btn>
              </v-tab-item>
              <v-tab-item class="exercise-preview__tab report">
                <p>Average rating</p>
                <div class="exercise-preview__rating" v-if="exercise.report && exercise.report.averageRating">
                  
                </div>
                <div class="exercise-preview__rating" v-else>
                  <h3>not available yet</h3>
                </div>
                <p v-if="exercise.report && exercise.report.reviews">{{exercise.report.reviews}} review{{exercise.report.reviews > 1?'s':''}}</p>
                <v-list class="exercise-preview__participants--list" v-if="exercise.report">
                  <v-list-item v-for="(participant, index) in exercise.report.participants" :key="'participant-'+index">
                    <img class="exercise-preview__participant--thumbnail" :src="participant.media && participant.media.thumbnailUrl ? participant.media.thumbnailUrl : require('@/assets/placeholder_image.png')"/>
                    <div class="exercise-preview__participant--text">
                      <h5>{{participant.firstName+' '+participant.lastName}}</h5>
                      <p>{{participant.date|moment('MMM DD, YYYY')}}</p>
                    </div>
                    <rating-stars :rating="participant.rating" :size="12"/>
                  </v-list-item>
                </v-list>
              </v-tab-item>
            </v-tabs-items>
          </v-card-text>
        </v-card>
  </v-dialog>
</template>

<script>
import { mapActions } from 'vuex'
import RatingStars from '@/components/exercises/RatingStars.vue'

export default {
  name: 'PreviewExerciseDialog',
  components: {
    RatingStars
  },
  props: {
    showDialog: {
      type: Boolean,
      default: false
    },
    exercise: {
      type: [Object, Boolean],
      default: ()=>{ return {}}
    }
  },
  watch: {
  },
  data () {
    return {
      tab: 0
    }
  },
  computed: {
    typeIcon() {
      let typeObj = {
        color: '',
        icon: ''
      }
      switch (this.exercise.type) {
        case 'SERIES':
          typeObj.color = '#FAC032'
          typeObj.icon = 'bhi-list'
          break;
        case 'ACTIVITY':
          typeObj.color = '#ED8938'
          typeObj.icon = 'bhi-activity'
          break;
        default: 
          typeObj.color = '#945EFF'
          typeObj.icon = 'bhi-exercise'
          break;
      }
      return typeObj
    },
  },
  methods: {
    ...mapActions('resourcesStates', [
      'downloadResourceByUrl',
      'checkFileAvailable',
      'getResourceInfo'
    ]),
    closeDialog() {
      this.tab = 0
      this.$emit('close-dialog')
    },
    onClickOutside() {
      this.closeDialog()
    },
    onKeydown(key) {
      if (key.code === "Escape" && key.isTrusted) this.closeDialog()
    },
    previewResource() {
      this.$emit('preview-media', this.exercise.media)
    }
  }
}
</script>

<style lang="scss">
@import "@/styles/variables.scss";
.exercise-preview {
  position: relative;
  & > .v-btn {
    position: absolute;
    top: 0;
    right: 0;
    z-index: 1;
  }
  &__thumbnail {
    width: 64px;
    height: 64px;
    object-fit: cover;
    border-radius: 8px;
    &--wrapper {
      position: relative;
      width: 64px;
      height: 64px;
    }
    &--icon {
      position: absolute;
      bottom: 2px;
      left: 2px;
      min-width: 20px;
      height: 20px;
      border-radius: 6px;
      display: flex;
      justify-content: center;
      align-items: center;
      z-index: 3;
      .v-icon {
        color: $bh-white;
        font-size:12px;
      }
      span {
        font-size: 0.6rem;
        padding-right: 2px;
        color:$bh-white;
        font-weight: bold;
        padding-top: 2px;
      }
    }
  }
  .headline {
    flex-wrap: nowrap;
  }
  &__title {
    margin-left: 8px;
    display: flex;
    flex-direction: column;
    min-width: 0;
    padding-right: 32px;
    flex-grow: 0;
    h5 {
      color:$bh-black;
      margin: 0;
    }
    p {
      font-weight: 400;
      font-size: 0.8rem;
      line-height: 1.2;
      margin: 0;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      min-width: 0;
    }
  }
  &__tab {
    padding-top: 8px;
    p {
      margin: 0;
    }
    &.quick-view {
      .v-image {
        margin-bottom: 8px;
        .gradient {
          background-image: linear-gradient(to top, rgba(0, 0, 0, 1) 20%,transparent 100%);
          position: absolute;
          top: 0;
          bottom: 0;
          left: 0;
          right: 0;
          z-index: 1;
        }
      }
    }
  }
  &__expand {
    position: absolute;
    bottom: 16px;
    right: 8px;
    z-index: 3;
    .v-icon {
      &::before {
        color:$bh-white;
      }
    }
  }
  &__desc {
    position: absolute;
    bottom: 16px;
    width: 100%;
    left: 0;
    text-align: center;
    color:$bh-white;
    &--wrapper {
      position: relative;
    }
    p {
      color: $bh-white;
      padding: 8px;
      z-index: 2;
      overflow: auto;
      font-size: 1rem;
      font-weight: 700;
      max-height: 100%;
    }
    .v-btn {
      margin-top: 8px;
    }
  }
  &__attributes {
    position: absolute;
    top:8px;
    left: 8px;
    right: 8px;
    display: flex;
    flex-wrap: wrap;
    gap:8px;
    div {
      background: $bh-blue;
      min-width: 64px;
      height: 64px;
      border-radius: 8px;
      color:$bh-white;
      padding:4px 12px;
      font-size: 0.8rem;
      strong {
        font-size: 26px;
        line-height: 36px;
        display: block;
      }
    }
  }
  &__rating {
    display: flex;
    align-items: center;
    margin-top: 3px;
    h3 {
      margin: 0 12px 0 0;
      padding-top: 2px;
      color: $bh-black;
    }
    span {
      font-size:0.8rem;
      line-height: 1;
      font-weight: 400;
      letter-spacing: 0;
    }
  }
  &__participants--list {
    margin-top: 16px;
    .v-list-item {
      padding:0;
    }
  }
  &__participant {
    &--thumbnail {
      width: 40px;
      height: 40px;
      object-fit: cover;
      border-radius: 50%;
    }
    &--text {
      flex-grow: 1;
      margin-left: 16px;
      h5 {
        margin: 0;
      }
      p {
        margin: 0;
        color:$bh-gray;
        font-size: 0.8rem;
      }
    }
  }
}
</style>
